var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrapeau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1243_15260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.583 8C15.583 12.0041 12.3371 15.25 8.33301 15.25C4.32894 15.25 1.08301 12.0041 1.08301 8C1.08301 3.99594 4.32894 0.75 8.33301 0.75C12.3371 0.75 15.583 3.99594 15.583 8Z",
    fill: "#F0F0F0",
    stroke: "#EEF2FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3331 7.99996C16.3331 4.56025 14.1621 1.6279 11.1157 0.497559V15.5024C14.1621 14.372 16.3331 11.4397 16.3331 7.99996V7.99996Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333008 7.99996C0.333008 11.4397 2.50404 14.372 5.55041 15.5024V0.497559C2.50404 1.6279 0.333008 4.56025 0.333008 7.99996Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1243_15260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeau);
export default __webpack_public_path__ + "static/media/drapeau.81e5cf257a952ff36ce824545afe0660.svg";
export { ForwardRef as ReactComponent };